export default __webpack_public_path__ + "static/decoration5-e634c8e0849d46c1121451d446ef9eac.png";